export default function Terms() {
  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "auto" }}>
      <h1>Terms & Conditions</h1>
      <p><strong>Effective Date:</strong> {new Date().toLocaleDateString()}</p>

      <h2>1. Introduction</h2>
      <p>
        Welcome to MDIH (Million Dollar Innovation Hub). By accessing or using
        our platform, you agree to comply with these Terms.
      </p>

      <h2>2. Platform Purpose</h2>
      <p>
        MDIH is an AI-powered platform designed to help users discover purpose,
        validate ideas, and build startups. The platform provides guidance,
        tools, and structured workflows.
      </p>

      <h2>3. No Guarantee of Success</h2>
      <p>
        MDIH does not guarantee business success, funding, or outcomes.
        All results depend on user execution and external factors.
      </p>

      <h2>4. AI Disclaimer</h2>
      <p>
        AI-generated suggestions are advisory only and should not be considered
        professional, financial, or legal advice.
      </p>

      <h2>5. User Responsibilities</h2>
      <ul>
        <li>Provide accurate information</li>
        <li>Maintain confidentiality of your account</li>
        <li>Use the platform ethically</li>
      </ul>

      <h2>6. Prohibited Activities</h2>
      <ul>
        <li>Illegal or fraudulent activity</li>
        <li>Misuse of AI outputs</li>
        <li>Attempt to hack or disrupt services</li>
      </ul>

      <h2>7. Account & Access</h2>
      <p>
        We reserve the right to suspend or terminate accounts violating these terms.
      </p>

      <h2>8. Payments & Subscriptions</h2>
      <p>
        Paid plans (Pro) provide additional features. Payments are non-refundable
        unless otherwise stated.
      </p>

      <h2>9. Intellectual Property</h2>
      <p>
        All platform content, workflows, and AI systems are owned by MDIH.
        Users retain ownership of their own inputs and outputs.
      </p>

      <h2>10. Limitation of Liability</h2>
      <p>
        MDIH shall not be liable for any direct or indirect damages arising from
        use of the platform.
      </p>

      <h2>11. Governing Law</h2>
      <p>
        These terms are governed by the laws of India.
      </p>

      <h2>12. Contact</h2>
      <p>
        For questions, contact: support@mdih.in
      </p>
    </div>
  );
}